/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getFsmCompletedWorkAllocationParams = zod.object({
  "id": zod.string().uuid()
})

export const getFsmCompletedWorkAllocationResponse = zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "payoutPoolAmount": zod.number().nullish(),
  "invoiceAmount": zod.number().nullish(),
  "allocationConfirmed": zod.boolean(),
  "status": zod.enum(['Processed', 'AwaitingTechMapping', 'NotPayable', 'NotReady', 'Failed', 'Abandoned']),
  "allocations": zod.array(zod.object({
  "id": zod.string().uuid(),
  "techEmail": zod.string().nullish(),
  "resolvedPayee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}).optional(),
  "amount": zod.number().nullish(),
  "suggestedAmount": zod.number(),
  "payoutRequestId": zod.string().uuid().nullish(),
  "payoutRequestStatus": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']).optional()
}))
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_APPROVE
 */
export const confirmFsmCompletedWorkAllocationParams = zod.object({
  "id": zod.string().uuid()
})

export const confirmFsmCompletedWorkAllocationBody = zod.object({
  "allocations": zod.array(zod.object({
  "techAssignmentId": zod.string().uuid(),
  "amount": zod.number()
}))
})

export const confirmFsmCompletedWorkAllocationResponse = zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "payoutPoolAmount": zod.number().nullish(),
  "invoiceAmount": zod.number().nullish(),
  "allocationConfirmed": zod.boolean(),
  "status": zod.enum(['Processed', 'AwaitingTechMapping', 'NotPayable', 'NotReady', 'Failed', 'Abandoned']),
  "allocations": zod.array(zod.object({
  "id": zod.string().uuid(),
  "techEmail": zod.string().nullish(),
  "resolvedPayee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}).optional(),
  "amount": zod.number().nullish(),
  "suggestedAmount": zod.number(),
  "payoutRequestId": zod.string().uuid().nullish(),
  "payoutRequestStatus": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']).optional()
}))
})

